/**
 * Centralized configuration for the Parent application.
 * Uses environment variables when available, falls back to localhost for development.
 */
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8090';
